export const emptySchemaExtensions = {
    comments: {},
    plugins: {},
    translatable: {},
};
//# sourceMappingURL=SchemaExtensions.js.map